// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"df7e0a1d","198":"251a9425"}[chunkId] + ".chunk.js";
};